module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-roadmap/bg.png",
      "swiper": _vm.swiper,
      "hasDownBtn": true
    }
  }, [_c('img', {
    staticClass: "main-roadmap ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-roadmap/历程.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-image ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-roadmap/shape02.png"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ec318ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Anniversary/PageRoadmap/index.vue
// module id = 1535
// module chunks = 8